import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyMacroUsagePage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-MacroUsageContainer" */ '../src/MacroUsage/MacroUsagePage.tsx'
			)
		).MacroUsagePage,
});
